module.exports = __webpack_public_path__ + "img/wz-7-4-2.ff01924b.jpg";